// Auth
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAILURE = "FETCH_PROFILE_FAILURE";

// Attendance
export const MARK_ATTENDANCE_REQUEST = "MARK_ATTENDANCE_REQUEST";
export const MARK_ATTENDANCE_SUCCESS = "MARK_ATTENDANCE_SUCCESS";
export const MARK_ATTENDANCE_FAILURE = "MARK_ATTENDANCE_FAILURE";
export const RESET_ATTENDANCE_STATE = "RESET_ATTENDANCE_STATE";
export const SET_LOCATION_ERROR = "SET_LOCATION_ERROR";
export const CLEAR_LOCATION_ERROR = "CLEAR_LOCATION_ERROR";

export const FETCH_ATTENDANCE_HISTORY_REQUEST = 'FETCH_ATTENDANCE_HISTORY_REQUEST';
export const FETCH_ATTENDANCE_HISTORY_SUCCESS = 'FETCH_ATTENDANCE_HISTORY_SUCCESS';
export const FETCH_ATTENDANCE_HISTORY_FAILURE = 'FETCH_ATTENDANCE_HISTORY_FAILURE';
